module.exports = __webpack_public_path__ + "static/img/jaka_logo_red.09dfd4ec.png";